import Icon from "@material-ui/icons/Person";
import AreasCreate from "./AreasCreate";
import AreasEdit from "./AreasEdit";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "areas",
  edit: AreasEdit,
  create: AreasCreate,
  icon: Icon,
};
